import { render, staticRenderFns } from "./ProductsEdit.vue?vue&type=template&id=12b275d6&scoped=true&"
import script from "./ProductsEdit.vue?vue&type=script&lang=js&"
export * from "./ProductsEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductsEdit.vue?vue&type=style&index=0&id=12b275d6&lang=scss&scoped=true&"
import style1 from "./ProductsEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b275d6",
  null
  
)

export default component.exports